export const MESSAGE_ID_ATTR = 'data-cv-message-history-id';